'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseLarge = require('wix-ui-icons-common/system/CloseLarge');

var _CloseLarge2 = _interopRequireDefault(_CloseLarge);

var _Button = require('../Backoffice/Button');

var _Button2 = _interopRequireDefault(_Button);

var _MessageBoxMarketerialLayout = require('./MessageBoxMarketerialLayout.scss');

var styles = _interopRequireWildcard(_MessageBoxMarketerialLayout);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MessageBoxMarketerialLayout = function (_WixComponent) {
  _inherits(MessageBoxMarketerialLayout, _WixComponent);

  function MessageBoxMarketerialLayout() {
    _classCallCheck(this, MessageBoxMarketerialLayout);

    return _possibleConstructorReturn(this, (MessageBoxMarketerialLayout.__proto__ || Object.getPrototypeOf(MessageBoxMarketerialLayout)).apply(this, arguments));
  }

  _createClass(MessageBoxMarketerialLayout, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          title = _props.title,
          content = _props.content,
          primaryButtonLabel = _props.primaryButtonLabel,
          secondaryButtonLabel = _props.secondaryButtonLabel,
          onPrimaryButtonClick = _props.onPrimaryButtonClick,
          onSecondaryButtonClick = _props.onSecondaryButtonClick,
          imageUrl = _props.imageUrl,
          onClose = _props.onClose,
          theme = _props.theme,
          imageComponent = _props.imageComponent;


      var headerClasses = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, styles.header, true), _defineProperty(_classNames, styles['header-' + theme], true), _classNames));

      return _react2.default.createElement(
        'div',
        { className: styles.root },
        _react2.default.createElement(
          'div',
          { className: headerClasses },
          _react2.default.createElement(
            'button',
            { type: 'button', className: styles.close, onClick: onClose, 'data-hook': 'close-button' },
            _react2.default.createElement(_CloseLarge2.default, null)
          ),
          imageComponent ? _react2.default.createElement(
            'div',
            { className: styles.headerImageComponent },
            imageComponent
          ) : _react2.default.createElement(
            'div',
            { className: styles.headerImage },
            _react2.default.createElement('img', { src: imageUrl, 'data-hook': 'header-image' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.title, 'data-hook': 'message-box-title' },
          title
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          content
        ),
        _react2.default.createElement(
          'div',
          { className: styles.buttonsContainer },
          primaryButtonLabel ? _react2.default.createElement(
            'div',
            { className: styles.primaryButtonContainer },
            _react2.default.createElement(
              _Button2.default,
              { theme: 'full' + theme, onClick: onPrimaryButtonClick, dataHook: 'primary-button' },
              primaryButtonLabel
            )
          ) : null,
          secondaryButtonLabel ? _react2.default.createElement(
            'div',
            { className: styles.secondaryButtonContainer },
            _react2.default.createElement(
              'span',
              { onClick: onSecondaryButtonClick, 'data-hook': 'secondary-button' },
              secondaryButtonLabel
            )
          ) : null
        )
      );
    }
  }]);

  return MessageBoxMarketerialLayout;
}(_WixComponent3.default);

MessageBoxMarketerialLayout.propTypes = {
  title: _propTypes2.default.node.isRequired,
  content: _propTypes2.default.node.isRequired,
  primaryButtonLabel: _propTypes2.default.string,
  secondaryButtonLabel: _propTypes2.default.string,
  onPrimaryButtonClick: _propTypes2.default.func,
  onSecondaryButtonClick: _propTypes2.default.func,
  imageUrl: _propTypes2.default.string,
  onClose: _propTypes2.default.func.isRequired,
  imageComponent: _propTypes2.default.node,
  theme: _propTypes2.default.oneOf(['blue', 'purple'])
};

MessageBoxMarketerialLayout.defaultProps = {
  theme: 'blue'
};

exports.default = MessageBoxMarketerialLayout;